var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveList({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_27_9",
    "data-name": "Component 27 \\u2013 9",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 5,
    height: 5,
    rx: 1,
    fill: "#2066a3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 13,
    height: 1,
    rx: 0.5,
    transform: "translate(6 2)",
    fill: "#2066a3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(0 7)",
    fill: "#2066a3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 13,
    height: 1,
    rx: 0.5,
    transform: "translate(6 9)",
    fill: "#2066a3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(0 14)",
    fill: "#2066a3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 13,
    height: 1,
    rx: 0.5,
    transform: "translate(6 16)",
    fill: "#2066a3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveList);
export default __webpack_public_path__ + "static/media/active_list.1d03a645e19b68a5be72a3d6216e4cd6.svg";
export { ForwardRef as ReactComponent };